// extracted by mini-css-extract-plugin
export default {"container":"Network_container__NbSAU"};